/// <amd-module name="Release/Helpers/Performance" />

import { IVssPerformanceService, TelemetryEventData } from "VSS/Platform/Performance";
import { IVssPageContext } from "VSS/Platform/Context";

export namespace PerformanceConstants {
    export const Area = "ReleaseManagement";
}

export namespace PerfScenarios {
    export const ReleasesHub = "VSO.ReleasesHub";
    export const ReleasesPivot = "VSO.ReleasesHub.ReleasesPivot";
    export const DeploymentsPivot = "VSO.ReleasesHub.DeploymentsPivot";
    export const AnalyticsPivot = "VSO.ReleasesHub.AnalyticsPivot";
    export const ActivePivot = "VSO.ReleasesHub.ActivePivot";
    export const AllPivot = "VSO.ReleasesHub.AllPivot";

    export const SearchResults = "VSO.ReleasesHub.SearchResults";
    export const NewFolder = "VSO.ReleasesHub.NewFolder";
    export const UpdateFolder = "VSO.ReleasesHub.UpdateFolder";
    export const DeleteFolder = "VSO.ReleasesHub.DeleteFolder";
    export const ExpandFolder = "VSO.ReleasesHub.ExpandFolder";
    export const MoveDefinition = "VSO.ReleasesHub.MoveDefinition";
    export const MoveAndRenameDefinition = "VSO.ReleasesHub.MoveAndRenameDefinition";
    export const FetchMoreDefinitions = "VSO.ReleasesHub.FetchMoreDefinitions";
}

export function endScenario(pageContext: IVssPageContext, scenario: string, isTTI: boolean = false) {
    const service = pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    service.endScenario(PerformanceConstants.Area, scenario, isTTI, undefined, undefined, undefined, additionalData);
}

export function startScenario(pageContext: IVssPageContext, scenario: string, isTTI: boolean = false) {
    const service = pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    service.startScenario(scenario, isTTI);
}

export function markTimeToInteractive(pageContext: IVssPageContext, scenario: string) {
    const service = pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    service.markTimeToInteractive(PerformanceConstants.Area, scenario, undefined, undefined, undefined, additionalData);
}

const additionalData: TelemetryEventData = { serviceInstanceType: "0000000d-0000-8888-8000-000000000000" } as TelemetryEventData;